<app-main-layout [clickBack]="onClickBack" [disableWatchingRoutes]="true">
  <div class="main-heading">
    <h2>Energy Efficiency</h2>
  </div>
  <div class="energy-efficiency-game">
    <h3 class="h5-m">U-Value</h3>
    <div class="cs-inner-html-16 mb-24">
      <p>A lower U-value means that a window is better at conserving energy (measure of energy savings).</p>
    </div>
    <div class="image">
      <img [src]="uValue?.image" alt="" class="brand-icon">
      <span class="u-value">{{uValue?.value}}</span>
    </div>
    <strong class="title">{{glassOptions?.title}}</strong>
    <div class="names-list">
      @for (item of glassOptions?.glassOptionsList; track item) {
        <div
          class="name"
          (click)="onSelect(item, 'glassOptions glassOptionsList')"
          [ngClass]="{ selected: item.selected }"
          >
          {{ item.name }}
        </div>
      }
    </div>
    <strong class="title">{{gasOptions?.title}}</strong>
    <div class="names-list">
      @for (item of gasOptions?.gasOptionsList; track item) {
        <div
          class="name"
          (click)="onSelect(item, 'gasOptions gasOptionsList')"
          [ngClass]="{ selected: item.selected }"
          >
          {{ item.name }}
        </div>
      }
    </div>
  </div>
  <div class="suggested-products">
    <strong class="title">Suggested WN Products:</strong>
    <div class="cs-inner-html-18">
      <p>
        <a href="https://www.windownation.com/most-energy-efficient-windows/#:~:text=ULTRA%20TRIPLE%20PANE%20ENERGY%20EFFICIENT%20WINDOW%20GLASS" target="_blank">ULTRA TRIPLE PANE</a>
      </p>
      <p>
        <a href="https://www.windownation.com/blog/post/what-is-low-e-glass-and-how-does-it-make-windows-more-energy-efficient/" target="_blank">ENERGY EFFICIENT WINDOW GLASS</a>
      </p>
    </div>
  </div>
</app-main-layout>